import Button from "@components/common/Button";
import { RAQ_FORM_TYPES } from "@components/utils/constants";
import useEnhancedConversions from "@hooks/useEnhancedConversions";
import useRequestQuote from "@hooks/useRequestQuote";
import { FiltersContext, IFiltersContext } from "@providers/FiltersProvider";

import { Dayjs } from "dayjs";
import {
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { useFormContext } from "react-hook-form";
import { ITag } from "./TripPreferences";
interface IRaQFormButton {
  isMobile: boolean;
  step: number;
  setStep: Dispatch<SetStateAction<number>>;
  children: any;
  tags?: {
    accommodationTags: ITag[];
    autoPlacesTags: ITag[];
    importantTags: ITag[];
    locations: ITag[];
  };
  isInStickyContainer?: boolean;
  dates: {
    startDate?: Dayjs | null;
    endDate?: Dayjs | null;
  };
  id: string;
}
const RaQFormButton = ({
  step,
  setStep,
  children,
  tags,
  dates,
  id,
}: IRaQFormButton): JSX.Element => {
  const formContext = useFormContext();
  const formRef = useRef<HTMLFormElement | null>(null);
  const [submittedData, setSubmittedData] = useState<any>(null);
  const { calendarUtils, syncFilterBar } = useContext(
    FiltersContext
  ) as IFiltersContext;
  const { onRequestSubmit, requestSucceeded } = useRequestQuote();
  const { setEnhancedConversions } = useEnhancedConversions();
  useEffect(() => {
    if (!(requestSucceeded && formRef.current && submittedData)) return;
    setEnhancedConversions({
      user_data: {
        full_name: submittedData.fullName,
        user_email: submittedData.email,
        phone_number: submittedData.phoneNumber,
      },
    });
    formRef.current.submit();
  }, [requestSucceeded, formRef.current, submittedData]);
  const submitHandler = (data: any): void => {
    setSubmittedData(data);
    const submitData = {
      dates,
      fullName: data.fullName,
      email: data.email,
      phoneNumber: data.phoneNumber,
      accommodations: data.accommodations,
      locations: tags?.locations,
      activities: data.activities,
      importantTags: data.importantTags,
      travellers: {
        adults: data.adults,
        teens: data.teens,
        children: data.children,
        rooms: data.rooms,
      },
      budgets: data.budgets,
      description: data.description,
      formType: RAQ_FORM_TYPES.FORM_B,
    } as any;
    onRequestSubmit(submitData).catch((e) => {
      console.error("onRequestSubmit error", e);
    });
    formContext.reset({
      ...formContext.control._defaultValues,
      datepicker: calendarUtils.inputDate,
    });
    syncFilterBar();
  };
  return (
    <div className="mx-4 desktop:mt-6">
      <Button
        id={id}
        type="submit"
        size={"medium"}
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        onClick={async (event) => {
          formRef.current = (event.target as HTMLButtonElement).form;
          if (step === 1) {
            event.preventDefault();
            const result = await formContext.trigger([
              "fullName",
              "email",
              "phoneNumber",
              "datepicker",
            ]);
            if (result) {
              setStep(2);
              if (tags) {
                formContext.setValue("accommodations", tags.accommodationTags);
                formContext.setValue("activities", tags.autoPlacesTags);
                formContext.setValue("importantTags", tags.importantTags);
              }
            }
          } else {
            if (step !== 3) {
              event.preventDefault();
              formContext
                .handleSubmit(submitHandler)()
                .catch(() => {});
            }
          }
        }}
      >
        <>{children}</>
      </Button>
    </div>
  );
};
export default RaQFormButton;
